import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const DEFAULT_DURATION = 0.5;
const DEFAULT_EASE = 'power2.inOut';
let _defaultDuration = DEFAULT_DURATION;
let _defaultEase = DEFAULT_EASE;

// =========================
// ScrollTo
// =========================
export function initScrollTo(duration?: number, ease?: string) {
    if (duration !== undefined) _defaultDuration = duration;
    if (ease !== undefined) _defaultEase = ease;
    document.addEventListener('click', handleScrollClick);
    handleInitialHash();
}

function handleScrollClick(e: Event) {
    const target = e.target as HTMLElement;
    const link = target.closest<HTMLAnchorElement>('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    const hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    const targetId = decodeURIComponent(href.substring(hashIndex + 1));
    const currentPath = href.substring(0, hashIndex);
    const isCurrentPage = !currentPath || currentPath === location.pathname;
    if (!isCurrentPage) return;

    const targetElement =
        document.getElementById(targetId) ||
        document.querySelector<HTMLElement>(`[name="${CSS.escape(targetId)}"]`) ||
        document.querySelector<HTMLElement>(`[name="${CSS.escape(targetId)}[]"]`);

    if (targetElement) {
        e.preventDefault();
        activateTabIfNeeded(targetElement);
        scrollToElement(targetElement, link);
    }
}

function activateTabIfNeeded(targetElement: HTMLElement) {
    if (!targetElement.classList.contains('tab-content')) return;
    const tab = targetElement.previousElementSibling;
    if (!tab) return;
    const radio = tab.querySelector<HTMLInputElement>('input[type="radio"]') ??
        (tab.matches('input[type="radio"]') ? tab as unknown as HTMLInputElement : null);
    if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function scrollToElement(targetElement: HTMLElement, triggerLink?: HTMLAnchorElement) {
    const offsetAttr = triggerLink?.dataset.scrollOffset;
    let offsetY = 0;

    if (offsetAttr) {
        const parts = offsetAttr.split('|').map(s => s.trim());
        for (const part of parts) {
            const num = parseFloat(part);
            if (!isNaN(num)) {
                offsetY += num;
            } else {
                const el = document.querySelector<HTMLElement>(part);
                if (el) offsetY += el.offsetHeight;
            }
        }
    }

    const durationAttr = triggerLink?.dataset.scrollDuration;
    const duration = durationAttr !== undefined ? parseFloat(durationAttr) || _defaultDuration : _defaultDuration;

    gsap.to(window, {
        duration,
        scrollTo: { y: targetElement, offsetY },
    });
}

function handleInitialHash() {
    const hash = location.hash;
    if (hash) {
        setTimeout(() => {
            const targetId = decodeURIComponent(hash.substring(1));
            const targetElement = document.getElementById(targetId);
            if (targetElement) {
                activateTabIfNeeded(targetElement);
                scrollToElement(targetElement);
            }
        }, 100);
    }
}
